import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

/**
 * Default reuse compares only routeConfig. With AC-30 stable `:moduleId` routes,
 * switching modules shares the same config and would reuse the list/edit components
 * (stale title, columns, and data). Recreate when moduleId changes; reuse otherwise.
 */
export class CustomReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle): void {
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== curr.routeConfig) {
      return false;
    }
    return this.moduleId(future) === this.moduleId(curr);
  }

  private moduleId(route: ActivatedRouteSnapshot): string | null {
    let r: ActivatedRouteSnapshot | null = route;
    while (r) {
      const id = r.paramMap.get('moduleId');
      if (id != null) {
        return id;
      }
      r = r.parent;
    }
    return null;
  }
}
